import React, { forwardRef } from 'react';
import { isNullOrWhiteSpace } from 'common/helpers/string';
import { FormattedDate } from 'react-intl';
import styles from './PrintDirectPaymentSummary.module.scss';

type Props = {
  Model: any;
  PageData: any;
};

const PrintDirectPaymentSummary = forwardRef(
  ({ Model, PageData }: Props, ref: any) => {
    return (
      <div id="container" ref={ref}>
        <header>
          <img className="logo" src={`${process.env.PUBLIC_URL}/hoist_logo_color.svg`} width="272" />
        </header>

        <h3>{PageData?.ThankYou}</h3>

        {Model?.IsAdyenPaymentPending && (
          <h3>{PageData?.PaymentPendingInfo}</h3>
        )}
        {Model?.IsPaymentPlanFinalizingError && (
          <h3 className="error">{PageData?.PaymentPlanFinalizingError}</h3>
        )}
        {!Model?.IsAdyenPaymentPending &&
          !Model?.IsPaymentPlanFinalizingError && (
            <h3>{PageData?.PaymentSuccessInfo}</h3>
          )}

        <table>
          {!isNullOrWhiteSpace(Model?.DebtReference) && (
            <tr>
              <td className="header">{PageData?.ClientDebtReference}</td>
              <td className="value">{Model?.DebtReference}</td>
            </tr>
          )}

          {Model?.DiscountedDebtBalance > 0 && (
            <>
              <tr>
                <td className="header strikethrough">
                  {PageData?.DebtBalance}
                </td>
                <td className="value strikethrough">

                  {Model?.FormattedCurrencyDebtBalance}
                </td>
              </tr>
              <tr>
                <td className="header">{PageData?.DiscountedDebtBalance}</td>
                <td className="value">
                  {Model?.FormattedCurrencyDiscountedBalance}
                </td>
              </tr>
            </>
          )}

          {Model?.PaymentAmount > 0 && (
            <tr>
              <td className="header">{PageData?.PaymentAmount}</td>
              <td className="value">
                {Model?.FormattedCurrencyPaymentAmount}
              </td>
            </tr>
          )}

          <tr>
            <td className="header">{PageData?.PaymentMethod}</td>
            <td className="value">{Model?.PaymentMethod}</td>
          </tr>
          <tr>
            <td className="header">{PageData?.PaymentTransactionIdentifier}</td>
            <td className="value">{Model?.PaymentTransactionNumber}</td>
          </tr>
          <tr>
            <td className="header">{PageData?.PaymentDate}</td>
            <td className="value">
              <FormattedDate
                value={Model.PaymentDate}
                day="2-digit"
                month="2-digit"
                year="numeric"
              />
            </td>
          </tr>
        </table>
      </div>
    );
  },
);

export default PrintDirectPaymentSummary;
